export default "__VITE_ASSET__CRS5vxyh__"